import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { v4 as uuidv4 } from 'uuid'
import { AlertColor } from '@mui/material'

type DialogColors = AlertColor //  'success' | 'error' | 'warning' | 'info'
type DialogActions = 'REFRESH' | 'UPDATE' | 'LOGOUT' | 'OK' | 'CLOSE' | 'SPINNER'
type DialogTypes = 'ALERT' | 'SNACKBAR' | 'LIST'
export interface Dialog<T = unknown> {
    id: string
    message?: string
    messageList?: T[]
    heading?: string
    color?: DialogColors
    action?: DialogActions
    type?: DialogTypes
    timeout?: number
}

export interface DialogState {
    dialog?: Dialog
}

export const useDialogStore = create<DialogState>()(
    devtools(
        (set, get) => ({
            dialog: undefined,
        }),
        {
            name: 'DialogStore',
        },
    ),
)

export type CreateDialogInput =
    | (Partial<Dialog> & Required<Pick<Dialog, 'message'>>)
    | (Partial<Dialog> & Required<Pick<Dialog, 'messageList'>>)

export const useDialog = () => useDialogStore((state) => state.dialog)
export const getDialog = () => useDialogStore.getState().dialog
export const setDialog = (dialog: Dialog) => useDialogStore.setState({ dialog })
export const clearDialog = (id?: string) => {
    if (!id || id === getDialog()?.id) {
        useDialogStore.setState({ dialog: undefined })
    }
}
export const createDialog = (dialog: CreateDialogInput) => {
    const type = dialog.type || 'SNACKBAR'
    const action = dialog.action || 'OK'
    const id = dialog.id || uuidv4()

    setDialog({ ...dialog, id, type, action })

    if (dialog.timeout) {
        setTimeout(() => {
            clearDialog(id)
        }, dialog.timeout)
    }
}
